import { __makeTemplateObject } from "tslib";
import styled from "styled-components";
export var TextAreaContainer = styled.label(templateObject_1 || (templateObject_1 = __makeTemplateObject(["\n  position: relative;\n  display: flex;\n  flex-direction: column;\n  gap: 4px;\n\n  font-size: 16px;\n  font-style: normal;\n  font-weight: 600;\n  line-height: 24px;\n  letter-spacing: 0.15px;\n  color: ", ";\n  width: 100%;\n\n  &:has(textarea:disabled) {\n    color: ", ";\n  }\n"], ["\n  position: relative;\n  display: flex;\n  flex-direction: column;\n  gap: 4px;\n\n  font-size: 16px;\n  font-style: normal;\n  font-weight: 600;\n  line-height: 24px;\n  letter-spacing: 0.15px;\n  color: ", ";\n  width: 100%;\n\n  &:has(textarea:disabled) {\n    color: ", ";\n  }\n"])), function (_a) {
    var theme = _a.theme;
    return theme.colors.neutral.default;
}, function (_a) {
    var theme = _a.theme;
    return theme.colors.neutral.light;
});
export var StyledTextArea = styled.textarea(templateObject_2 || (templateObject_2 = __makeTemplateObject(["\n  padding: ", ";\n  border-radius: ", ";\n  border: 1px solid\n    ", ";\n  background-color: ", ";\n\n  color: ", ";\n  font-family: ", ";\n  font-size: ", ";\n  font-style: normal;\n  font-weight: 400;\n  line-height: 20px;\n  letter-spacing: 0.1px;\n\n  &::-webkit-resizer {\n    display: none;\n  }\n\n  &::placeholder {\n    color: ", ";\n    font-family: ", ";\n    font-size: 14px;\n    font-style: normal;\n    font-weight: 400;\n    line-height: 20px;\n    letter-spacing: 0.1px;\n  }\n\n  &:hover {\n    border-color: ", ";\n  }\n\n  &:active {\n    border-color: ", ";\n  }\n\n  &:focus {\n    border-color: ", ";\n    outline: none;\n  }\n\n  ", "\n\n  ", "\n\n  &:disabled {\n    color: ", ";\n    background-color: unset;\n    border-color: ", ";\n  }\n"], ["\n  padding: ", ";\n  border-radius: ", ";\n  border: 1px solid\n    ", ";\n  background-color: ", ";\n\n  color: ", ";\n  font-family: ", ";\n  font-size: ", ";\n  font-style: normal;\n  font-weight: 400;\n  line-height: 20px;\n  letter-spacing: 0.1px;\n\n  &::-webkit-resizer {\n    display: none;\n  }\n\n  &::placeholder {\n    color: ", ";\n    font-family: ", ";\n    font-size: 14px;\n    font-style: normal;\n    font-weight: 400;\n    line-height: 20px;\n    letter-spacing: 0.1px;\n  }\n\n  &:hover {\n    border-color: ", ";\n  }\n\n  &:active {\n    border-color: ", ";\n  }\n\n  &:focus {\n    border-color: ", ";\n    outline: none;\n  }\n\n  ", "\n\n  ", "\n\n  &:disabled {\n    color: ", ";\n    background-color: unset;\n    border-color: ", ";\n  }\n"])), function (_a) {
    var theme = _a.theme;
    return theme.components.input.input.padding[theme.device];
}, function (_a) {
    var theme = _a.theme;
    return theme.components.input.input.borderRadius[theme.device];
}, function (_a) {
    var variant = _a.variant, theme = _a.theme;
    return theme.colors.neutral[variant === "default" ? "default" : "lightest"];
}, function (_a) {
    var variant = _a.variant, theme = _a.theme;
    return variant === "default" ? "transparent" : theme.colors.neutral.lightest;
}, function (_a) {
    var theme = _a.theme;
    return theme.colors.neutral.default;
}, function (_a) {
    var theme = _a.theme;
    return theme.typography.family.default;
}, function (_a) {
    var theme = _a.theme;
    return theme.components.input.input.fontSize[theme.device];
}, function (_a) {
    var theme = _a.theme;
    return theme.colors.neutral.light;
}, function (_a) {
    var theme = _a.theme;
    return theme.typography.family.default;
}, function (_a) {
    var theme = _a.theme;
    return theme.colors.neutral.dark;
}, function (_a) {
    var theme = _a.theme;
    return theme.colors.neutral.darker;
}, function (_a) {
    var theme = _a.theme;
    return theme.colors.blue.darker;
}, function (_a) {
    var $hasError = _a.$hasError, theme = _a.theme;
    return $hasError && "border-color: ".concat(theme.colors.red.default, ";");
}, function (_a) {
    var $isLoading = _a.$isLoading;
    return $isLoading && "padding-right: 40px;";
}, function (_a) {
    var theme = _a.theme;
    return theme.colors.neutral.light;
}, function (_a) {
    var theme = _a.theme;
    return theme.colors.neutral.light;
});
var templateObject_1, templateObject_2;
//# sourceMappingURL=styles.js.map